import React, { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from 'react';
// import Jessibuca from './jessibuca';
import { new265webJsFn, New265WebJs, Web265JsConfig } from './h265web';
import { Descriptions, Modal, Row, Col, Typography, Spin } from 'antd';
import { postStreamsPlay, deleteStreams } from '@/api/channel';
import Jessibuca from './jessibuca';

export type WsFlvRef = {
  play: (params: { channelId: string; deviceId: string }) => void;
  close: () => void;
  isPlaying: () => void;
  // initial: () => void;
  destroy: () => void;
};

// const WsFlvJessibuca = forwardRef<WsFlvRef>((props: {}, ref) => {
//   const ContainerRef = useRef<HTMLDivElement>(null);
//   const jessibucaRef = useRef<Jessibuca>(null);

//   const initial = () => {
//     // console.log(process.env.PUBLIC_URL);
//     // @ts-ignore
//     // eslint-disable-next-line new-cap
//     jessibucaRef.current = new (window.Jessibuca as Jessibuca)({
//       container: ContainerRef.current,
//       videoBuffer: 0.2, // 缓存时长
//       isResize: false,
//       text: '',
//       loadingText: '',
//       // useMSE: true,
//       // useWCS: true,
//       debug: false,
//       showBandwidth: true, // 显示网速
//       decoder: `${process.env.PUBLIC_URL}/decoder.js`,
//       supportDblclickFullscreen: true,
//       autoWasm: true,

//       operateBtns: {
//         fullscreen: true,
//         screenshot: true,
//         play: true,
//         audio: true,
//         recorder: false,
//       },
//       forceNoOffscreen: true,
//       isNotMute: false,
//     });
//   };

//   useImperativeHandle(ref, () => {
//     return {
//       play: (url: string) => {
//         if (!jessibucaRef.current) {
//           initial();
//         }
//         jessibucaRef.current?.play(url);
//       },
//       close: () => {
//         jessibucaRef.current?.close();
//       },
//       isPlaying: () => {
//         return jessibucaRef.current?.isPlaying;
//       },
//       initial,
//       destroy: () => {
//         jessibucaRef.current?.destroy();
//       },
//     };
//   });

//   useEffect(() => {
//     return () => {
//       // console.log('destroy');
//       // jessibucaRef.current?.close();
//       jessibucaRef.current?.destroy();
//     };
//   }, []);
//   return <div ref={ContainerRef} style={{ width: '100%', height: '100%' }}></div>;
// });

const WsFlvJessibuca = forwardRef<WsFlvRef, { id: string; isShowInfo?: boolean }>((props, ref) => {
  const ContainerRef = useRef<HTMLDivElement>(null);
  // const webRef = useRef<New265WebJs>(null);
  const jessibucaRef = useRef<Jessibuca>(null);

  const initial = (url: string) =>
    new Promise((resolve) => {
      try {
        // @ts-ignore
        // eslint-disable-next-line new-cap
        jessibucaRef.current = new (window.Jessibuca as Jessibuca)({
          container: ContainerRef.current,
          videoBuffer: 0.2, // 缓存时长
          isResize: false,
          text: '',
          loadingText: '',
          // useMSE: true,
          // useWCS: true,
          debug: false,
          showBandwidth: true, // 显示网速
          decoder: `${process.env.PUBLIC_URL}/decoder.js`,
          supportDblclickFullscreen: true,
          autoWasm: true,

          operateBtns: {
            fullscreen: true,
            screenshot: true,
            play: true,
            audio: true,
            recorder: false,
          },
          forceNoOffscreen: true,
          isNotMute: false,
        });
        jessibucaRef.current?.play(url);
        resolve('');
      } catch {
        resolve('');
      }
      // console.log(webRef.current);
    });

  useEffect(() => {
    return () => {
      // console.log('destroy');
      // jessibucaRef.current?.close();
      jessibucaRef.current?.destroy();
    };
  }, []);

  const playRef = useRef<{ id?: string; url?: string }>({});

  const onClose = () => {
    try {
      playRef.current?.id && deleteStreams(playRef.current as { id: string });
    } catch {
    } finally {
      jessibucaRef.current?.destroy();
      // @ts-ignore
      jessibucaRef.current = null;
    }
  };

  const [info, setInfo] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const onStart = async ({ channelId: channel_id, deviceId: device_id }: { channelId: string; deviceId: string }) => {
    // console.log({ channel_id, device_id });
    if (jessibucaRef.current) {
      onClose();
    }
    setLoading(true);
    try {
      const res = await postStreamsPlay({ channel_id, device_id });
      playRef.current = res.result;
      setInfo(res.result || {});
      // console.log(res.result, res);
      const flvUrl = location.protocol === 'https:' ? res.result?.https_flv : res.result?.flv;

      if (flvUrl) await initial(flvUrl);
    } catch {
      // console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => {
    return {
      play: (params: { channelId: string; deviceId: string }) => {
        onStart(params);
      },
      close: onClose,
      isPlaying: () => {
        // return webRef.current?.isPlaying?.();
      },
      // initial,
      destroy: () => {
        onClose();
      },
    };
  });

  useEffect(() => {
    return () => {
      onClose();
    };
  }, []);
  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <Row style={{ height: '100%' }} wrap={false}>
        <Col flex="auto" style={{ position: 'relative' }}>
          {loading && (
            <div
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                textAlign: 'center',
                background: 'gray',
                zIndex: 10,
              }}
            >
              <Spin></Spin>
            </div>
          )}
          <div ref={ContainerRef} id={props.id} style={{ width: '100%', height: '100%' }}></div>
        </Col>
        {props.isShowInfo && info.flv && (
          <Col flex="300px" style={{ background: '#fff', overflowY: 'auto' }}>
            <div style={{ padding: 24, paddingTop: 10 }}>
              <Descriptions
                column={1}
                bordered
                size="small"
                layout="vertical"
                title="流信息"
                items={'rtmp、rtsp、hls、flv、fmp_4、ts、https_flv'
                  .split('、')
                  .map((key) => ({ key, label: key, children: <Typography.Paragraph copyable={{ text: info[key], tooltips: false }}>{info[key]}</Typography.Paragraph> }))}
              ></Descriptions>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
});

// const PLAYER_CORE_TYPE_DEFAULT = 0; // 默认播放器
// const PLAYER_CORE_TYPE_CNATIVE = 1; // 备用播放内核
const token =
  'base64:QXV0aG9yOmNoYW5neWFubG9uZ3xudW1iZXJ3b2xmLEdpdGh1YjpodHRwczovL2dpdGh1Yi5jb20vbnVtYmVyd29sZixFbWFpbDpwb3JzY2hlZ3QyM0Bmb3htYWlsLmNvbSxRUTo1MzEzNjU4NzIsSG9tZVBhZ2U6aHR0cDovL3h2aWRlby52aWRlbyxEaXNjb3JkOm51bWJlcndvbGYjODY5NCx3ZWNoYXI6bnVtYmVyd29sZjExLEJlaWppbmcsV29ya0luOkJhaWR1';
const config: Web265JsConfig = {
  // player: 'glplayer',
  // @ts-ignore
  width: '100%',
  // @ts-ignore
  height: '100%',
  token,
  extInfo: {
    moovStartFlag: true,
    coreProbePart: 0.1,
    ignoreAudio: 0,
  },
};

export const WsFlvH256Web = forwardRef<WsFlvRef, { id: string; isShowInfo?: boolean }>((props, ref) => {
  const ContainerRef = useRef<HTMLDivElement>(null);
  const webRef = useRef<New265WebJs>(null);

  const initial = (url: string) =>
    new Promise((resolve) => {
      try {
        const videoContainer = document.getElementById(props.id);
        console.log(videoContainer?.childNodes);
        Array.from(videoContainer?.children || []).forEach((item, index) => {
          console.log(item);
          // if (index) {
          //   videoContainer?.removeChild(item);
          // } else {
          //   item.setAttribute('controls', 'true');
          // }
          if (index) videoContainer?.removeChild(item);
        });
        // console.log(process.env.PUBLIC_URL);
        // @ts-ignore
        // eslint-disable-next-line new-cap
        webRef.current = new (window.new265webjs as new265webJsFn)(url, { ...config, player: props.id });
        // webRef.current!.onRender = (...args) => {
        //   console.log(args);
        // };
        webRef.current!.onLoadFinish = () => {
          const videoContainer = document.getElementById(props.id);
          // console.log(videoContainer, videoContainer?.children);
          videoContainer?.children?.[0]?.setAttribute('controls', 'true');
          videoContainer?.children?.[0]?.setAttribute('class', 'ipc-video');
          // @ts-ignore
          if (!webRef.current?.isPlaying?.()) webRef.current?.play?.();
          resolve('');
        };
        webRef.current!.do();
      } catch {
        resolve('');
      }
      // console.log(webRef.current);
    });

  const playRef = useRef<{ id?: string; url?: string }>({});

  const onClose = () => {
    try {
      playRef.current?.id && deleteStreams(playRef.current as { id: string });
    } catch {
    } finally {
      webRef.current?.release();
      // @ts-ignore
      webRef.current = null;
    }
  };

  const [info, setInfo] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const onStart = async ({ channelId: channel_id, deviceId: device_id }: { channelId: string; deviceId: string }) => {
    // console.log({ channel_id, device_id });
    if (webRef.current) {
      onClose();
    }
    setLoading(true);
    try {
      const res = await postStreamsPlay({ channel_id, device_id });
      playRef.current = res.result;
      setInfo(res.result || {});
      // console.log(res.result, res);

      if (res.result?.flv) await initial(res.result?.flv);
    } catch {
      // console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => {
    return {
      play: (params: { channelId: string; deviceId: string }) => {
        onStart(params);
      },
      close: onClose,
      isPlaying: () => {
        return webRef.current?.isPlaying?.();
      },
      // initial,
      destroy: () => {
        onClose();
      },
    };
  });

  useEffect(() => {
    return () => {
      // console.log('destroy');
      // jessibucaRef.current?.close();

      onClose();
    };
  }, []);
  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <Row style={{ height: '100%' }} wrap={false}>
        <Col flex="auto" style={{ position: 'relative' }}>
          {loading && (
            <div
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                textAlign: 'center',
                background: 'gray',
                zIndex: 10,
              }}
            >
              <Spin></Spin>
            </div>
          )}
          <div ref={ContainerRef} id={props.id} style={{ width: '100%', height: '100%' }}></div>
        </Col>
        {props.isShowInfo && info.flv && (
          <Col flex="300px" style={{ background: '#fff', overflowY: 'auto' }}>
            <div style={{ padding: 24, paddingTop: 10 }}>
              <Descriptions
                column={1}
                bordered
                size="small"
                layout="vertical"
                title="流信息"
                items={'rtmp、rtsp、hls、flv、fmp_4、ts、https_flv'
                  .split('、')
                  .map((key) => ({ key, label: key, children: <Typography.Paragraph copyable={{ text: info[key], tooltips: false }}>{info[key]}</Typography.Paragraph> }))}
              ></Descriptions>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
});

export type WsFlvModalRef = {
  show: (params: { channelId: string; deviceId: string }) => void;
  hide: () => void;
};

export const WsFlvWithUrl = memo(({ id, isShowInfo, ...params }: { id: string; isShowInfo?: boolean } & { channelId: string; deviceId: string }) => {
  const wsFlvRef = useRef<WsFlvRef>(null);
  // console.log({ url });
  useEffect(() => {
    if (params.channelId && params.deviceId) {
      const isPlaying = wsFlvRef.current?.isPlaying();
      if (isPlaying) wsFlvRef.current?.close();
      wsFlvRef.current?.play(params);
    } else wsFlvRef.current?.close();
  }, [params.channelId, params.deviceId]);

  useEffect(() => {
    // wsFlvRef.current?.play();
    return () => {
      wsFlvRef.current?.destroy();
    };
  }, []);

  return <WsFlvJessibuca ref={wsFlvRef} id={id} isShowInfo={isShowInfo}></WsFlvJessibuca>;
});

export const WsFlvModal = forwardRef<WsFlvModalRef>((props: {}, ref) => {
  const [open, setOpen] = useState<boolean>(false);

  const wsFlvRef = useRef<WsFlvRef>(null);
  const hide = () => {
    setOpen(false);
    wsFlvRef.current?.close();
  };
  useImperativeHandle(ref, () => {
    return {
      show: (params: { channelId: string; deviceId: string }) => {
        setOpen(true);
        wsFlvRef.current?.play(params);
      },
      hide,
    };
  });
  return (
    <Modal
      open={open}
      onCancel={() => {
        hide();
      }}
      forceRender
      centered
      zIndex={100}
      title={'播放'}
      width={'80vw'}
      cancelText="关闭"
      footer={(_origin, { CancelBtn }) => <CancelBtn></CancelBtn>}
    >
      <div style={{ width: '100%', height: '500px' }}>
        <WsFlvJessibuca ref={wsFlvRef} id="modal-player"></WsFlvJessibuca>
      </div>
    </Modal>
  );
});

// export default WsFlvH256Web;
